import { Table, Button, Box, Icon, H3, T, Spinner, Tbody, Tr, Td, Thead, Th, Card } from '@veracity/vui';
import { useChecklists } from '../api/checklists';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import TemplateSelectModal from '../components/TemplateSelectModal';
import { useState } from 'react';
import { useTemplates } from '../api/templates';

const ChecklistsPage = () => {
  const navigate = useNavigate();
  const { data: checklists, isLoading, error } = useChecklists();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data: templates } = useTemplates();

  if (isLoading) return (
    <Box alignItems="center" justifyContent="center" minH={700}>
      <Spinner />
    </Box>
  );

  if (error) return (
    <Box alignItems="center" elevation={2} flexDirection="column" justifyContent="center" maxW={580} minW={580} p={3}>
      <Box><Icon color="energyRed.45" name="falExclamationTriangle" size="xxl" /></Box>
      <H3 my={2}>Something went wrong</H3>
      <T>The operation could not be completed. Try again later.</T>
      <Button mt={3} onClick={() => window.location.reload()}>Try again</Button>
    </Box>
  );

  const handleCreateChecklist = () => {
    setIsModalOpen(true);
  }

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      {/* <H3 mb={6} textAlign="center">Checklists</H3> */}
      <Card p={4}>
        <Table variant="basic">
          <Thead>
            <Tr>
              <Th>Tag</Th>
              <Th>Name</Th>
              <Th>State</Th>
              <Th>Closing date</Th>
              <Th>Action</Th>
            </Tr>
          </Thead>
          <Tbody>
            {(checklists || []).map(checklist => (
              <Tr key={checklist.id}>
                <Td fontSize="sm">{checklist.tag}</Td>
                <Td fontSize="sm">{checklist.name}</Td>
                <Td>{checklist.status ? 'Open' : 'Closed'}</Td>
                <Td>{checklist.dateClosed ? format(new Date(checklist.dateClosed), "PPp") : ""}</Td>
                <Td>
                  <Button
                    variant={checklist.status ? 'primaryDark' : 'secondaryDark'}
                    size="sm"
                    onClick={() => navigate(`/checklist/${checklist.id}`)}
                  >
                    {checklist.status ? 'Open' : 'View'}
                  </Button>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Card>

      <Box mt={4} display="flex" justifyContent="center">
        <Button variant="primaryDark" onClick={() => navigate('/templates')} mr={4} text="View Templates" />
          <Button text="New Checklist" 
                onClick={handleCreateChecklist}
          />
      </Box>

      <TemplateSelectModal
            isOpen={isModalOpen}
            onClose={handleCloseModal}
            templates={templates}
      />
    </>
  );
};

export default ChecklistsPage;